/*
 * File: RequestedShipDateRangeSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 13 Dec 2021 7:47:02 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { DatePicker, Space } from 'antd';
import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { grannyBirdApi } from 'redux/services/grannyBird';
import { setEndDate, setStartDate } from 'redux/services/grannyBird/poReceiptParams';

const { RangePicker } = DatePicker;

export const DateRangeFilter: FC = () => {
  const dispatch = useDispatch();

  const handleChange = (dateString: string[]): void => {
    if (!dateString[0] && !dateString[1]) {
      dispatch(setStartDate(undefined));
      dispatch(setEndDate(undefined));
    } else {
      dispatch(setStartDate(dateString[0]));
      dispatch(setEndDate(dateString[1]));
    }
    dispatch(grannyBirdApi.util.invalidateTags(['PurchaseOrders']));
  };

  // Clears state on unmount
  useEffect(() => {
    return (): void => {
      dispatch(setStartDate(undefined));
      dispatch(setEndDate(undefined));
    };
  }, [dispatch]);

  return (
    <Space direction="vertical" size="small">
      <RangePicker style={{ borderRadius: 5 }} format="YYYY/MM/DD" onChange={(_: unknown, dateString: string[]): void => handleChange(dateString)} />
    </Space>
  );
};
